<template src="./WeatherStationCreate.html"> </template>


<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'WeatherStationCreate',
    data() {
        return {
            creatingOld: null,
            formValidationWs: true,
            textRules: [
                v => !!v || 'Item is required'
            ],
        }
    },
    computed: {

        ...mapState({
            vws: state => state.map.newVirtualStationLatLon,

            wsCreating: state => state.ws.wsCreating,
        }),

        wsCreatingStatus() {
            //if (this.creatingOld == this.wsCreating) return this.wsCreating;
            if (this.wsCreating.data.name === undefined) return this.wsCreating;

            if (this.wsCreating.data.name)
                this.createAlert({message: 'Virtual Weather Station has been successfully created!', type: 'success'});
            else if (this.wsCreating.data.code == 'ERROR')
                this.createAlert({message: 'Error creating Virtual Weather Station. Please try again or contact the system admin!', type: 'error'});
            
            return this.wsCreating;
        },

        newVirtualStation: {
            get() {
                return this.vws;
            },
            set(v) {
                return v;
            }
        },

    },
    methods: {
        ...mapActions({
            setVirtualStationLatLon: 'setVirtualStationLatLon',
            setVirtualWeatherStation: 'setVirtualWeatherStation',

            setAlert: 'setAlert',

            getStations: 'getStations',

            resetWsCreating: 'resetWsCreating',
        }),

        createAlert(alert) {
            this.setAlert(alert);
            this.getStations();
            this.onCloseCreateVirtualStation();
            this.resetWsCreating();
        },

        onSaveVirtualStation() {
            this.$refs.formWs.validate();
            
            if (this.newVirtualStation.name.length > 0)
                if (this.newVirtualStation.latitude.toString().length > 0)
                    if (this.newVirtualStation.longitude.toString().length > 0)
                        this.setVirtualWeatherStation(this.newVirtualStation);
        },

        onCloseCreateVirtualStation() {

            if (this.$refs.formWs)
                this.$refs.formWs.resetValidation();

            this.newVirtualStation.status = false;
            this.newVirtualStation.name = "";
            this.newVirtualStation.latitude = null;
            this.newVirtualStation.longitude = null;

            this.setVirtualStationLatLon(this.newVirtualStation);
            this.showCreateVirtualStation = !this.showCreateVirtualStation;

            this.$emit('onCloseCreateVirtualStation', false)
        },

        onVirtualStationStatus() {
            this.newVirtualStation.status = true;
            this.setVirtualStationLatLon(this.newVirtualStation);
        }
    },
    mounted() {
        this.newVirtualStation.status = true;
        this.setVirtualStationLatLon(this.newVirtualStation);
    },
}
</script>

<style lang="scss" src="./WeatherStationCreate.scss"></style>